module.exports = __webpack_public_path__ + "img/ITS-Logo.ca59d5d3.png";